import { render } from "./support.vue?vue&type=template&id=44992a1e"
import script from "./support.vue?vue&type=script&lang=js"
export * from "./support.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__